import React from 'react';
import '../styles/Header.css';

const Header = ({ currentLang }) => {
    return (
        <header className="header">
            <div className="header-background"></div>
            <div className="container">
                <div className="logo-container">
                    <h1 className="logo">
                        <span className="logo-text">{currentLang === 'ar' ? 'علي العوض' : 'Ali Alawadh'}</span>
                        <span className="logo-glow"></span>
                    </h1>
                    <p className="tagline">
                        {currentLang === 'ar' 
                            ? 'فن الفخار والخزف اليدوي' 
                            : 'Pottery Art & Handcrafted Ceramics'}
                    </p>
                </div>
            </div>
        </header>
    );
};

export default Header;

